import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from "./woundAssessment.module.scss";
import { CreateAssessment } from "./createAssessment";
import { AssessmentHistory } from "../../core/Patients/assessmentHistory";
import { WoundPhotoAssessment } from "../../core/Patients/woundPhotoAssessment";
import { setAssessmentHistory, setMergeNavigateSuccess, setMergeWoundSuccess, setTransferNavigateSuccess, setTransferWoundSuccess } from "../../../app/patientSlice";
import { modalOpenData } from "../../../utils/patientsHelper";
import { setDeleteAdminChildStatus } from "../../../app/appSlice";
import WoundAssessmentList from "./WoundAssessment/woundAssessmentList";

export const WoundAssessment = ({
  patientData,
  deleteHistoryAssessment,
  deleteAssessmentChildLevel,
  childLevelDelete,
  setChildLevelDelete,
}) => {
  const dispatch = useDispatch();
  const mergeWoundSuccess = useSelector((state) => state.patient.mergeWoundSuccess);
  const transferWoundSuccess = useSelector((state) => state.patient.transferWoundSuccess);

  const [assessmentModal, setAssessmentModal] = useState(false);
  const [assessId, setAssessId] = useState();
  const [modalShow, setmodalShow] = useState(false);
  const [assessmentTitle, setAssessmentTitle] = useState("");
  const [modalTitlteId, setModalTitlteId] = useState("");
  const [newWoundOptionChildLevel, setNewWoundOptionChildLevel] = useState(false);

  useEffect(() => {
    // dispatch(setDeleteAdminStatus(false));
    dispatch(setDeleteAdminChildStatus(false));
  }, []);

  useEffect(() => {
    if (newWoundOptionChildLevel) {
      setTimeout(() => {
        setNewWoundOptionChildLevel(false);
      }, 4500);
    }
  }, [newWoundOptionChildLevel]);

  useEffect(() => {
      if (!mergeWoundSuccess && !transferWoundSuccess) return;
  
      const timer = setTimeout(() => {
        if (mergeWoundSuccess) {
          dispatch(setMergeWoundSuccess(null));
          dispatch(setMergeNavigateSuccess(false));
        }
        if (transferWoundSuccess) {
          dispatch(setTransferWoundSuccess(null));
          dispatch(setTransferNavigateSuccess(false));
        }
      }, 5000);
  
      return () => clearTimeout(timer);
    }, [mergeWoundSuccess, transferWoundSuccess, dispatch]);

  const modalOpen = (id, title) => {
    dispatch(setAssessmentHistory({}));
    modalOpenData(id, title, setAssessmentTitle, setModalTitlteId, setmodalShow);
  };

  return (
    <>
      {mergeWoundSuccess !== null && (
        <div className={mergeWoundSuccess !== null ? `alert alert-success ${style.form_alert}` : "d-none"}>
          {mergeWoundSuccess !== null && mergeWoundSuccess}
        </div>
      )}
      {transferWoundSuccess !== null && (
        <div className={transferWoundSuccess !== null ? `alert alert-success ${style.form_alert}` : "d-none"}>
          {transferWoundSuccess !== null && transferWoundSuccess}
        </div>
      )}
      {newWoundOptionChildLevel && <div className={`alert alert-success ${style.form_alert}`}>{"Successfully saved as a new wound"}</div>}

      <div>
        {patientData?.moreInfo?.ne1WMSStatus === 1 && <WoundPhotoAssessment patientData={patientData} dispatch={dispatch} />}

        <>
          {patientData?.moreInfo?.ne1WMSStatus === 1 && (
            <>
              {/* Re-eval modal  */}
              {assessmentModal && <CreateAssessment modalClose={setAssessmentModal} reEval={true} assessmentId={assessId} />}

              {/* heading && <PatientHeading heading={heading} /> */}
              <WoundAssessmentList
                patientData={patientData}
                modalOpen={modalOpen}
              />

              {modalShow && (
                <AssessmentHistory
                  modalOpen={modalShow}
                  modalClose={"modalClose"}
                  setmodalShow={setmodalShow}
                  assessmentTitle={assessmentTitle}
                  modalTitlteId={modalTitlteId}
                  deleteAssessment={deleteAssessmentChildLevel}
                  deleteHistoryAssessment={deleteHistoryAssessment}
                  setChildLevelDelete={setChildLevelDelete}
                  childLevelDelete={childLevelDelete}
                  setNewWoundOptionChildLevel={setNewWoundOptionChildLevel}
                />
              )}
            </>
          )}
          {patientData?.moreInfo?.ne1WMSStatus === 0 && <div
              className="m-3"
              style={{
                background: "#fff",
                boxShadow: "0px 10px 20px #e4e4e4",
                padding: "1rem",
                paddingLeft: "32px",
                transform: "translateX(-15px)",
              }}
            >
              <h3>Patient is Inactive</h3>
            </div>}
        </>
      </div>
    </>
  );
};
